import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardActionArea,
  CardContent,
  useTheme,
} from "@mui/material";
import { useNavigate } from "react-router-dom";


export default function RelatedTools({ relatedTools }) {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Box mt={8}>
      <Typography
        variant="h5"
        align="center"
        fontWeight="bold"
        gutterBottom
        sx={{
          background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        🔗 Explore Related Tools
      </Typography>

      <Grid container spacing={3} justifyContent="center" mt={2}>
        {relatedTools.map((tool) => (
          <Grid item key={tool.path} xs={12} sm={6} md={4}>
            <Card
              sx={{
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                borderRadius: "20px",
                "&:hover": {
                  transform: "translateY(-6px)",
                  boxShadow: "0 10px 25px rgba(0, 0, 0, 0.15)",
                },
              }}
              elevation={3}
            >
              <CardActionArea onClick={() => navigate(tool.path)}>
                <CardContent
                  sx={{
                    textAlign: "center",
                    padding: "24px",
                    backgroundColor: "#fafafa",
                  }}
                >
                  <Typography variant="h4" component="div" mb={1}>
                    {tool.emoji}
                  </Typography>
                  <Typography
                    variant="h6"
                    fontWeight="600"
                    color="text.primary"
                  >
                    {tool.name}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
